import { LayoutDefinition } from './layout'

// A panel absent from here is still available via the menus — a stored layout is never auto-extended (ADR-020).
const defaultLayout: LayoutDefinition = {
  panels: [
    { panel: 'metricsOverview', span: 'full' },
    { panel: 'trackProgress', span: 'full' },
    { panel: 'contentProgress', span: 'three-quarters' },
    { panel: 'reflections', span: 'quarter' },
  ],
}

export default defaultLayout
